<template>
    <div id="report-ticket">
        <div class="overall-content">
            <div class="chart-container">
                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon users-icon">
                            <md-icon>people</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.ticketCountByUser") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.ticketCountByUserDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <TicketDistributionsByUser :filters="filters" :loading="loading" :data="data.byUser" />
                    </div>
                </div>

                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon status-icon">
                            <md-icon>donut_large</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.ticketCountByStatus") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.ticketCountByStatusDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <TicketDistributionsByStatus :filters="filters" :loading="loading" :data="data.byStatus" />
                    </div>
                </div>

                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon timeseries-icon">
                            <md-icon>timeline</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t("report.ticketCountByStatus") }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.ticketCountTimeseriesDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <TicketCountTimeSeriesChart :filters="filters" :loading="loading" :data="data.timeSeries" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import TicketDistributionsByUser from "./TicketDistributionsByUser.vue";
import TicketDistributionsByStatus from "./TicketDistributionsByStatus.vue";
import TicketCountTimeSeriesChart from "./TicketCountTimeSeriesChart.vue";

const log = log2("ReportTicket");
export default {
    name: "ReportTicket",
    components: { TicketCountTimeSeriesChart, TicketDistributionsByStatus, TicketDistributionsByUser },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                byUser: [],
                byStatus: {},
                timeSeries: {},
            },
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            REPORT_API.ticketDistributionsAll(this.filters)
                .then((res) => {
                    log("ticketDistributionsAll data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-ticket {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .overall-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        background: var(--color-bg-neutral, #f5f5f5);
        width: 100%;
        min-height: 100vh;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .report-card {
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
                overflow: hidden;
                transition: box-shadow 0.2s ease;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
                }

                .report-card-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 20px 24px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                    .report-card-icon {
                        width: 44px;
                        height: 44px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        i {
                            font-size: 22px !important;
                            color: #fff;
                        }

                        &.users-icon {
                            background: linear-gradient(135deg, #3b82f6, #2563eb);
                        }

                        &.status-icon {
                            background: linear-gradient(135deg, #f59e0b, #d97706);
                        }

                        &.timeseries-icon {
                            background: linear-gradient(135deg, #a855f7, #7c3aed);
                        }
                    }

                    .report-card-title {
                        h2 {
                            font-size: 18px;
                            font-weight: 600;
                            margin: 0;
                            color: #1a1a1a;
                        }

                        .report-card-subtitle {
                            font-size: 13px;
                            color: #6b7280;
                            margin: 2px 0 0 0;
                        }
                    }
                }

                .report-card-body {
                    padding: 20px 24px;
                }
            }
        }
    }
}
</style>